import {importProvidersFrom, NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SdTooltipModule} from '@sd/ui/tooltip';
import {SdDatepickerModule} from '@sd/ui/datepicker';
import {SdFormFieldModule} from '@sd/ui/form-field';
import {SdInputModule} from '@sd/ui/input';
import {SdSelectModule} from '@sd/ui/select';
import {SdButtonModule} from '@sd/ui/button';
import {SdProgressSpinnerModule} from '@sd/ui/progress-spinner';
import {SdIconModule} from '@sd/ui/icon';
import {SdCheckboxModule} from '@sd/ui/checkbox';
import {SdRadioModule} from '@sd/ui/radio';
import {SdButtonToggleModule} from '@sd/ui/button-toggle';
import {SdNativeDateModule, SdOptionModule, SdRippleModule} from '@sd/ui/core';
import {SdDividerModule} from '@sd/ui/divider';
import {SdMenuModule} from '@sd/ui/menu';
import {SdProgressBarModule} from '@sd/ui/progress-bar';
import {SdSortModule} from '@sd/ui/sort';
import {SdTableModule} from '@sd/ui/table';
import {SdTabsModule} from '@sd/ui/tabs';
import {SdSidenavModule} from '@sd/ui/sidenav';
import {SdBottomSheetModule} from "@sd/ui/bottom-sheet";
import {CdkTableModule} from "@angular/cdk/table";
import {CdkTreeModule} from "@angular/cdk/tree";
import {SdPaginatorModule} from "@sd/ui/paginator";
import {SdStepperModule} from "@sd/ui/stepper";
import {SdExpansionModule} from "@sd/ui/expansion";
import {SdChipsModule} from "@sd/ui/chips";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {DialogModule} from "@angular/cdk/dialog";
import {OverlayModule} from "@angular/cdk/overlay";
import {SdBadgeModule} from "@sd/ui/badge";
import {SdAutocompleteModule} from "@sd/ui/autocomplete";
import {SdDialogModule} from "@sd/ui/dialog";
import {CdkStepperModule} from "@angular/cdk/stepper";
import {SdCardModule} from "@sd/ui/card";
import {A11yModule} from "@angular/cdk/a11y";
import {LazyLoadImageModule} from "ng-lazyload-image";
import {SdListModule} from "@sd/ui/list";
import {LaddaModule} from "angular2-ladda";
import { SdTreeModule } from '@sd/ui/tree';
import {SdSlideToggleModule} from "@sd/ui/slide-toggle";
import {CustomRouterService} from "../services/custom-router.service";
import {CustomToastrService} from "./toastr/custom-toastr.service";
import {TranslateLoader, TranslateModule, TranslatePipe} from "@ngx-translate/core";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";
import {SdToolbarModule} from "@sd/ui/toolbar";
import {HttpNoInterceptorsService} from "./translation/http-no-interceptors.service";
import {createCustomTranslateLoader} from "../models/translator";
import {CrudService} from "./crud/crud.service";
import {NgxPermissionsModule} from "ngx-permissions";
import {ClipboardModule} from "@angular/cdk/clipboard";
import {ColorPickerModule} from "ngx-color-picker";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    LocalizeRouterPipe,
    NgOptimizedImage,
    LaddaModule.forRoot({
      spinnerColor: "#C0C0C0",
      spinnerSize: 30,
      style: "zoom-out",
    }),
    NgxPermissionsModule.forChild(),
    OverlayModule,
    DialogModule,
  ],
  declarations: [
  ],
  exports: [
    TranslatePipe,
    LocalizeRouterPipe,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPermissionsModule,

    NgOptimizedImage,
    ClipboardModule,
    ColorPickerModule,

    SdToolbarModule,
    SdTooltipModule,
    SdSelectModule,
    SdFormFieldModule,
    SdDatepickerModule,
    SdInputModule,
    SdCardModule,
    SdButtonModule,
    ReactiveFormsModule,
    SdCheckboxModule,
    SdIconModule,
    SdProgressSpinnerModule,
    SdRadioModule,
    SdButtonToggleModule,
    SdDividerModule,
    SdMenuModule,
    SdProgressBarModule,
    SdRippleModule,
    SdSidenavModule,
    SdSortModule,
    SdTableModule,
    SdTabsModule,
    A11yModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    SdAutocompleteModule,
    SdBadgeModule,
    SdBottomSheetModule,
    SdChipsModule,
    SdStepperModule,
    SdDialogModule,
    LazyLoadImageModule,
    SdExpansionModule,
    SdNativeDateModule,
    SdPaginatorModule,
    SdOptionModule,
    DragDropModule,
    LaddaModule,
    SdExpansionModule,
    SdTreeModule,
    SdListModule,
    SdSlideToggleModule,
  ],
  providers: [
    CustomRouterService,
    CustomToastrService,
    CrudService,
    importProvidersFrom(
      TranslateModule.forChild(
        {
          loader: {
            provide: TranslateLoader,
            useFactory: (httpNoInterceptorsService: HttpNoInterceptorsService) => {
              return createCustomTranslateLoader(httpNoInterceptorsService.getHttpClient());
            },
            deps: [HttpNoInterceptorsService]
          }
        }
      ),
    ),
  ]
})
export class SharedModule {
}
